import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { kpiKeys } from '../queries/keys';
import { kpiPaths } from '../queries/paths';

// Server-state hook for the reproductive dashboard (api-reference/admin-kpis.md).
// One read-pure GET, multinivel por ?view=. El cohorte se ancla en la sesión OPU
// y es filtrable por cliente / finca / rango (fechas 'YYYY-MM-DD', TZ-safe).

// Drop empty filters so the cache key is stable and we don't send '' params.
function cleanFilters(filters = {}) {
    const out = {};
    // `month`/`type` aplican a view=schedule (agenda mensual, 0110).
    for (const k of ['client_id', 'farm_id', 'from', 'to', 'month', 'type']) {
        const v = filters[k];
        if (v !== '' && v != null) out[k] = v;
    }
    return out;
}

export function useKpis(view = 'summary', filters = {}) {
    const params = { view, ...cleanFilters(filters) };
    return useQuery({
        queryKey: kpiKeys.view(view, params),
        queryFn:  ({ signal }) => api.get(kpiPaths.base(), { params, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}
